import { render, staticRenderFns } from "./goldenpipslist.vue?vue&type=template&id=799c5c04&scoped=true&"
import script from "./goldenpipslist.vue?vue&type=script&lang=js&"
export * from "./goldenpipslist.vue?vue&type=script&lang=js&"
import style0 from "./goldenpipslist.vue?vue&type=style&index=0&id=799c5c04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799c5c04",
  null
  
)

export default component.exports